import { bindable, customAttribute, INode, PLATFORM } from 'aurelia';

/**
 * Toggle custom attribute for adding/removing a CSS class from
 * whatever element the attribute is attached onto
 *
 */

@customAttribute('toggle')
export class Toggle {
    @bindable activeClass = 'active';
    @bindable targetElement;
    @bindable widthConstraint = 980;
    @bindable widthDirection = '<';

    private activeStateClass = 'active';
    private window;
    private targetElementActual;

    constructor(@INode readonly element: INode) {}

    bound() {
        this.targetElementChanged();

        this.activeStateClass = this.activeClass;
    }

    attached() {
        this.window = window;

        if (!this.targetElement) {
            this.targetElementActual = this.element;
        }

        this.element.addEventListener('click', this.clickCallback);
    }

    detached() {
        this.window = null;
        this.targetElementActual = null;
        this.element.removeEventListener('click', this.clickCallback);
    }

    clickCallback = () => {
        if (this.targetElementActual) {
            if (
                (this.widthDirection === '<' &&
                    this.window.innerWidth < this.widthConstraint) ||
                (this.widthDirection === '>' &&
                    this.window.innerWidth > this.widthConstraint)
            ) {
                this.targetElementActual.classList.toggle(
                    this.activeStateClass
                );
            }
        }
    };

    targetElementChanged() {
        this.targetElementActual = document.querySelector(this.targetElement);
    }

    activeClassChanged(newClass) {
        this.activeStateClass = newClass;
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = Toggle;

    // @ts-ignore
    const proto = Toggle.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }